import {TooltipForChild} from "@cdx/common";
import {
  Box,
  DSIconButton,
  DSIconGhost,
  DSIconHandSingle,
  DSIconHandSingleDashed,
  Row,
} from "@cdx/ds";
import {canAddHandToQueueErrors, canDiscardHandFromQueue} from "../hand-queue/hand-queue-utils";
import {DSDeckPickerButton} from "./DSDeckPicker";
import {getCardProjectIfRestricted} from "./card-container-utils";
import {CardPropOverlayForNewCard} from "../../components/RichTextarea/Lexical/CardPropChangeForChild";
import {Root} from "../../cdx-models/Root";
import {ArenaCtx} from "../card-panel/card-panel-utils";
import {MouseEventHandler} from "react";

const PutOnHandArea = ({
  card,
  onCardChange,
  root,
}: {
  card: any;
  root: Root;
  onCardChange: (opt: any) => void;
}) => {
  const meId = root.loggedInUser?.$meta.get("id", null);
  const ownerIsMe = !card.assignee || card.assignee?.id === meId;

  const addError = canAddHandToQueueErrors(card, (card.assignee || root.loggedInUser).id, root);
  if (!canDiscardHandFromQueue(card)) return null;

  const getTooltip = () => {
    if (addError) return `Can't add to hand: ${addError}`;
    const target = ownerIsMe ? "your Hand" : "Owner's Hand";
    if (card.putInQueue) return `Card will be added to ${target}`;
    return `Click to add to ${target}`;
  };

  const disabled = Boolean(addError && !card.putInQueue);

  const handleClick: MouseEventHandler = (e) => {
    onCardChange((prev: any) => ({...prev, putInQueue: !card.putInQueue}));
  };

  const active = card.putInQueue;

  return (
    <TooltipForChild tooltip={getTooltip()} delayed targetIsDisabled={disabled}>
      <DSIconButton
        onClick={handleClick}
        icon={active ? <DSIconHandSingle size={20} /> : <DSIconHandSingleDashed size={20} />}
        variant="tertiary"
        size="sm"
        disabled={disabled}
        active={active}
      />
    </TooltipForChild>
  );
};

type CreateCardTopAreaProps = {
  card: any;
  arenaCtx: ArenaCtx;
  root: Root;
  onCardChange: (opts: any) => void;
  category: string;
  inboxDeck: any;
};
export const CreateCardTopArea = ({
  card,
  arenaCtx,
  root,
  onCardChange,
  category,
}: CreateCardTopAreaProps) => {
  return (
    <Row sp="4px" align="center" height="28px">
      <Box size={14} color="secondary" flex="none" bold>
        New Card
      </Box>
      <Row ml="auto" sp="8px" align="center">
        {arenaCtx.type !== "deck" && (
          <DSDeckPickerButton
            deck={card.deck}
            maxChars={25}
            root={root}
            onPickDeckId={(deckId) => onCardChange({deckId})}
            allowSetNone={card.deck ? {label: "No deck", icon: <DSIconGhost />} : undefined}
            category={category}
            canModify
            getProjects={() => getCardProjectIfRestricted({card, root})}
            renderOverlay={({overlayProps, close}) => (
              <CardPropOverlayForNewCard
                card={card}
                onChange={({deckId}) => onCardChange({deckId})}
                overlayProps={overlayProps}
                onClose={close}
                initialTab="deck"
              />
            )}
          />
        )}
        <PutOnHandArea card={card} onCardChange={onCardChange} root={root} />
      </Row>
    </Row>
  );
};
